module.exports = __webpack_public_path__ + "static/media/bagy1.abd26f5a.png";